import React from 'react';
import CategoryAnalysis from '../../components/CategoryAnalysis';

const CategoryAnalysisPage = () => {
    return (
        <div className="p-4">
            <CategoryAnalysis />
        </div>
    );
};

export default CategoryAnalysisPage;
